import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const TermsPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" align="center" gutterBottom>
        Terms of Service
      </Typography>
      
      <Paper sx={{ p: 4, mt: 4 }}>
        <Typography variant="h5" gutterBottom>
          1. Introduction
        </Typography>
        <Typography variant="body1" paragraph>
          Welcome to Laprecio. These Terms of Service ("Terms") govern your access to and use of the Laprecio platform, including any content, functionality, and services offered on or through laprecio.com (the "Platform").
        </Typography>
        <Typography variant="body1" paragraph>
          By accessing or using the Platform, you agree to be bound by these Terms. If you do not agree to these Terms, you must not access or use the Platform.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          2. Definitions
        </Typography>
        <Typography variant="body1" paragraph>
          "User" refers to any individual or entity that accesses or uses the Platform.
        </Typography>
        <Typography variant="body1" paragraph>
          "Content" refers to any information, data, text, software, graphics, messages, or other materials that are posted, uploaded, or otherwise made available through the Platform.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          3. Account Registration
        </Typography>
        <Typography variant="body1" paragraph>
          To access certain features of the Platform, you may be required to register for an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.
        </Typography>
        <Typography variant="body1" paragraph>
          You are responsible for safeguarding your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account or any other breach of security.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          4. User Conduct
        </Typography>
        <Typography variant="body1" paragraph>
          You agree not to use the Platform in any way that:
        </Typography>
        <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
          <li>Violates any applicable law or regulation</li>
          <li>Infringes the rights of any third party</li>
          <li>Attempts to interfere with the proper functioning of the Platform</li>
          <li>Engages in any fraudulent or deceptive activity</li>
          <li>Transmits any viruses, malware, or other harmful code</li>
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          5. Intellectual Property
        </Typography>
        <Typography variant="body1" paragraph>
          The Platform and its original content, features, and functionality are owned by Laprecio and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          6. Privacy
        </Typography>
        <Typography variant="body1" paragraph>
          Your use of the Platform is also governed by our Privacy Policy, which is incorporated into these Terms by reference.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          7. Limitation of Liability
        </Typography>
        <Typography variant="body1" paragraph>
          In no event shall Laprecio, its directors, employees, partners, agents, suppliers, or affiliates be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Platform.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          8. Governing Law
        </Typography>
        <Typography variant="body1" paragraph>
          These Terms shall be governed by and construed in accordance with the laws of [Jurisdiction], without regard to its conflict of law provisions.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          9. Changes to Terms
        </Typography>
        <Typography variant="body1" paragraph>
          We reserve the right to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          10. Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about these Terms, please contact us at hello@laprecio.com.
        </Typography>
        
        <Box sx={{ mt: 4 }}>
          <Typography variant="body2" color="textSecondary">
            Last updated: {new Date().toLocaleDateString()}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default TermsPage;
